module.exports = __webpack_public_path__ + "static/media/6.39ccb394.jpg";